import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e0fabf98"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "general" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Iniciar Sesión")
], -1))
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = { class: "grid" }
const _hoisted_5 = { class: "form-floating" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "nombre" }, "Rol:", -1))
const _hoisted_7 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Navbar),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("form", null, [
        _createElementVNode("fieldset", null, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _withDirectives(_createElementVNode("input", {
                  id: "nombre",
                  type: "password",
                  placeholder: "Nombre",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.role) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, $data.role]
                ]),
                _hoisted_6
              ])
            ])
          ]),
          _createElementVNode("button", {
            class: "btn btn-primary",
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => ($options.login()), ["prevent"])),
            disabled: 
                  !$data.role
      
          }, "Ingresar", 8, _hoisted_7)
        ])
      ])
    ])
  ], 64))
}